import { render, staticRenderFns } from "./PrescSuprimentos.vue?vue&type=template&id=2eb11296&"
import script from "./PrescSuprimentos.vue?vue&type=script&lang=js&"
export * from "./PrescSuprimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports